import React from "react"
import { Row, Col, Container } from "react-bootstrap"
import Accordion from "react-bootstrap/Accordion"
import styled from "styled-components"
import AnimationContainer from "components/animation-container"
import { Helmet } from "react-helmet"
import { Link } from "gatsby"

class Digicert extends React.Component {
  shouldComponentUpdate() {
    return false
  }

  constructor(props) {
    super(props)
    this.state = {
      height: 0,
      width: 0,
    }
  }

  updateDimensions = () => {
    if (this.state.height !== window.innerHeight) {
      this.setState({ height: window.innerHeight })
    }
    if (this.state.width !== window.innerWidth) {
      this.setState({ width: window.innerWidth })
    }
  }

  componentDidMount() {
    this.setState({ height: window.innerHeight, width: window.innerWidth })
    window.addEventListener("resize", this.updateDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions)
  }

  render() {
    // Datos estructurados para preguntas y respuestas
    const PreguntasRespuestas = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          "name": "¿Qué es el error ERR_SSL_PROTOCOL_ERROR?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Este error ocurre cuando el navegador no puede establecer una conexión segura debido a problemas con la configuración SSL/TLS, el servidor o el dispositivo del cliente. Las causas comunes incluyen: Certificado SSL mal configurado en el servidor, protocolos o cifrados SSL/TLS desactualizados, problemas de red en el servidor o el cliente, y fecha/hora incorrectas en el dispositivo del cliente."
          }
        },
        {
          "@type": "Question",
          name: "¿Necesito acreditación ONAC para un SSL?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "No, la acreditación ONAC no es necesaria para comprar o usar certificados SSL en Colombia. Este mito es común, pero puedes proteger tu sitio, app o plataforma sin esta acreditación.",
          },
        },
        {
          "@type": "Question",
          name: "¿Qué es un certificado SSL y para qué sirve?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Un certificado SSL protege la información sensible (como datos de usuarios) en sitios web, apps y plataformas mediante cifrado. Mejora la confianza del usuario, el SEO, y es esencial para seguridad online.",
          },
        },
        {
          "@type": "Question",
          name: "¿Cuánto cuesta un certificado SSL en Colombia?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Los precios de certificados SSL en Colombia varían: desde $50.000/año para DV (RapidSSL) hasta $2.000.000/año para EV (DigiCert). Ofrecemos opciones para pymes y empresas.",
          },
        },
        {
          "@type": "Question",
          name: "¿Cómo elegir un SSL para mi app en Bogotá?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Para apps en Bogotá, elige un SSL según tu necesidad: DV para apps básicas, OV para empresas, o EV para máxima confianza. Contáctanos para una recomendación personalizada.",
          },
        },
        {
          "@type": "Question",
          name: "¿Qué es un certificado SSL SAN?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Un certificado SSL SAN (Subject Alternative Name) protege múltiples dominios o subdominios con un solo certificado, ideal para empresas con varios sitios en Colombia.",
          },
        },
        {
          "@type": "Question",
          name: "¿Puedo obtener un SSL gratis con hosting?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Sí, ofrecemos SSL gratis con nuestros planes de hosting en Bogotá, Medellín, Barranquilla, Pereira y Cali. Perfecto para sitios y apps básicas.",
          },
        },
        {
          "@type": "Question",
          name: "¿Qué es un SSL Wildcard?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Un certificado SSL Wildcard protege un dominio y todos sus subdominios ilimitados (*.dominio.com). Ideal para desarrolladores y redes de sitios en Colombia.",
          },
        },
        {
          "@type": "Question",
          name: "¿Por qué elegir DigiCert en Medellín?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "DigiCert ofrece máxima seguridad y confianza para plataformas en Medellín, con validación EV y soporte premium. Es ideal para empresas que priorizan profesionalismo.",
          },
        },
        {
          "@type": "Question",
          name: "¿Cuánto tarda la emisión de un SSL DV?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Un certificado SSL DV se emite en minutos tras verificar el dominio, lo que lo hace ideal para sitios y apps que necesitan seguridad rápida en Colombia.",
          },
        },
        {
          "@type": "Question",
          name: "¿Cómo protege un SSL mi plataforma en Barranquilla?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Un SSL cifra los datos de tu plataforma en Barranquilla, protegiendo a tus usuarios y mejorando la confianza. Es esencial para extranets y apps locales.",
          },
        },
        {
          "@type": "Question",
          name: "¿Son seguros los SSL para pymes en Bucaramanga?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Sí, los certificados SSL son seguros y accesibles para pymes en Bucaramanga. Ofrecemos opciones económicas (desde $50.000/año) con garantía de 30 días.",
          },
        },
        {
          "@type": "Question",
          name: "¿Qué SSL es mejor para una tienda online en Cali?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Para tiendas online en Cali, recomendamos un SSL EV (DigiCert) para máxima confianza o un SSL OV (GeoTrust) para pymes. Aseguran pagos y datos de clientes.",
          },
        },
      ],
    }

    const Section = styled.section`
            position: relative;
            overflow: hidden;
            background-color: #fff;
            padding: 40px 0 50px 0;
            .heading {
                width: 100%;            
            @media (max-width: 767px) {
                padding: 10px 0 50px 0;           
            }
            @media (min-width:768px) and (max-width:1500px) {
                padding: 20px 0 50px 0;              
            }
        `

    const ServiceRow = styled(Row)`
      margin-top: 10px;
    `
    const ServiceRow1 = styled(Row)`
      margin-top: 50px;
    `

    const TecText = styled.p`
      font-size: 18px;
      font-weight: 300;
      color: #4c4c4c !important;
    `

    const Text = styled.p`
      font-size: 17px;
      font-family: roboto, sans-serif;
      color: #777;
    `
    const Color = styled.span`
      font-weight: bold;
      color: #78c91c;
    `
    const TextaSpan = styled(Link)`
      color: #78c91c;
      transition: 0.5s;
      &:hover {
        color: #000;
        text-decoration: none;
      }
    `
    const Texta = styled.a`
      color: #78c91c;
      transition: 0.5s;
      &:hover {
        color: #000;
        text-decoration: none;
      }
    `

    const ServiceList = styled.ul`
      padding: 0;
      margin: 11px 0 0 0;
    `

    const ServiceListElement = styled.li`
      list-style: none;
      color: #000;
      font-weight: 300;
      font-size: 17px;
      font-family: roboto, sans-serif;
      margin: 5px 0px;
      &::before {
        display: inline-block;
        content: "";
        border-radius: 2.5px;
        height: 5px;
        width: 5px;
        margin-right: 10px;
        background-color: #78c91c;
        position: relative;
        bottom: 2.5px;
      }
    `
    const Heading2 = styled.h2`
      transform: translate(0px, -100px);
      transition: 1s;
      margin-top: 150px;
      font-size: 80px;
      line-height: 80px;
      font-family: Teko;
      font-weight: 500;
      color: #000;
      text-align: center;
      text-transform: uppercase;
    `
    const ColorV = styled.span`
      color: #65ff00;
      font-family: Teko;
    `

    return (
      <Section id="QA">
        <Container>
          {/* Llama al componente PreguntasRespuestas directamente */}
          <Helmet>
            <script type="application/ld+json">
              {JSON.stringify(PreguntasRespuestas)}
            </script>
          </Helmet>
          <Heading2>
            Preguntas Frecuentes sobre <ColorV>Certificados SSL</ColorV>
          </Heading2>
          <ServiceRow>
            <Col md={12}>
              <TecText>
                ¿Tienes dudas sobre certificados SSL? Encuentra respuestas
                claras sobre precios, tipos, acreditación ONAC y más, para
                proteger tus sitios, apps y plataformas en Bogotá, Medellín,
                Barranquilla, Cali, Pereira, Bucaramanga y toda Colombia.
              </TecText>
            </Col>
          </ServiceRow>
          <ServiceRow1>
            <Col md={12}>
              <AnimationContainer animation="fadeInDown" delay={500}>
                <Accordion defaultActiveKey="0">
                  {/* Item 0 */}
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      ¿Qué es un certificado SSL y para qué sirve?
                    </Accordion.Header>
                    <Accordion.Body>
                      <Text>
                        Un certificado SSL protege la información sensible (como
                        datos de usuarios) en sitios web, apps y plataformas
                        mediante cifrado. Mejora la confianza del usuario, el
                        SEO, y es esencial para seguridad online.
                      </Text>
                      <Text>
                        <Color>Autenticación:</Color> Verifican la identidad de
                        una entidad, como una empresa, antes de establecer una
                        conexión segura.
                      </Text>
                      <Text>
                        <Color>Cifrado:</Color> Encriptan los datos que se
                        transmiten entre el servidor y el navegador del usuario,
                        lo que evita que los datos sean interceptados o
                        manipulados por terceros.
                      </Text>
                      <Text>
                        <Color>Integridad de los datos:</Color> Garantizan que
                        los datos transmitidos no se alteren durante la
                        transferencia entre el servidor y el navegador.
                      </Text>
                      <Text>
                        En última instancia, los certificados SSL ayudan a
                        proteger la privacidad de los usuarios y la seguridad de
                        los datos mientras navegan por sitios web. Además, la
                        mayoría de los navegadores web modernos muestran un
                        ícono de candado o una barra verde en la barra de
                        direcciones para indicar que la conexión es segura
                        mediante HTTPS.
                      </Text>
                    </Accordion.Body>
                  </Accordion.Item>
                  {/* Item 1 */}
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>
                      ¿Cuánto cuesta un certificado SSL en Colombia?
                    </Accordion.Header>
                    <Accordion.Body>
                      <Text>
                        Los precios de los certificados SSL en Colombia varían:
                        desde $50.000/año para DV (RapidSSL) hasta
                        $19.000.000/año para EV (DigiCert). Ofrecemos opciones
                        para pymes y empresas.
                      </Text>
                    </Accordion.Body>
                  </Accordion.Item>
                  {/* Item 2 */}
                  <Accordion.Item eventKey="2">
                    <Accordion.Header>
                      ¿Qué son los Certificados SSL SAN?
                    </Accordion.Header>
                    <Accordion.Body>
                      <Text>
                        Un certificado SSL SAN (Subject Alternative Name)
                        protege múltiples dominios o subdominios con un solo
                        certificado, ideal para empresas con varios sitios en
                        Colombia.
                      </Text>
                    </Accordion.Body>
                  </Accordion.Item>
                  {/* Item 3 */}
                  <Accordion.Item eventKey="3">
                    <Accordion.Header>
                      ¿Es necesaria la acreditación ONAC para vender
                      certificados SSL?
                    </Accordion.Header>
                    <Accordion.Body>
                      <Text>
                        No, la acreditación ONAC no es necesaria para comprar o
                        usar certificados SSL en Colombia. Este mito es común,
                        pero puedes proteger tu sitio, app o plataforma sin esta
                        acreditación.
                      </Text>
                    </Accordion.Body>
                  </Accordion.Item>
                  {/* Item 4 */}
                  <Accordion.Item eventKey="4">
                    <Accordion.Header>
                      ¿Entonces están la privacidad y confidencialidad
                      garantizadas sin la acreditación ONAC?
                    </Accordion.Header>
                    <Accordion.Body>
                      <Text>
                        La privacidad, seguridad, disponibilidad, integridad de
                        procesos y confidencialidad están garantizadas durante
                        todo el proceso de solicitud, configuración y emisión de
                        los certificados SSL, tanto del lado de la autoridad
                        certificadora, como de parte de VASCO Solutions.
                        Cumplimos con los últimos estándares en ISO27001 2022.
                      </Text>
                    </Accordion.Body>
                  </Accordion.Item>
                  {/* Item 5 */}
                  <Accordion.Item eventKey="5">
                    <Accordion.Header>
                      ¿Cómo instalar un certificado SSL?
                    </Accordion.Header>
                    <Accordion.Body>
                      <Text>Así funciona el proceso:</Text>
                      <ServiceList>
                        <ServiceListElement>
                          Crear su solicitud (CSR)
                        </ServiceListElement>
                        <ServiceListElement>
                          Comprobar su CSR
                        </ServiceListElement>
                        <ServiceListElement>
                          Presenta tu solicitud.
                        </ServiceListElement>
                        <ServiceListElement>
                          Validación completa de identidad.
                        </ServiceListElement>
                        <ServiceListElement>
                          Instale su certificado.
                        </ServiceListElement>
                        <ServiceListElement>
                          Compruebe su instalación
                        </ServiceListElement>
                        <ServiceListElement>
                          Establecer control de gestión – para revocar,
                          reeditar, etc.
                        </ServiceListElement>
                        <ServiceListElement>
                          Renovar antes de que su certificado expire.
                        </ServiceListElement>
                      </ServiceList>
                      <Text>
                        La instalación de un certificado SSL GeoTrust puede
                        variar según el servidor web que estés utilizando. Aquí
                        hay una guía general para la instalación de un
                        certificado GeoTrust SSL:
                      </Text>
                      <ServiceList>
                        <ServiceListElement>
                          Obtén el Certificado SSL: GeoTrust te proporcionará el
                          certificado SSL, que incluirá archivos como el
                          certificado principal, la clave privada y,
                          posiblemente, el archivo de la cadena intermedia.
                        </ServiceListElement>
                        <ServiceListElement>
                          Accede al Panel de Control de tu Servidor Web: Ingresa
                          al panel de control de tu servidor web. Esto puede ser
                          cPanel, Plesk, Apache, Nginx, Microsoft IIS, entre
                          otros.
                        </ServiceListElement>
                        <ServiceListElement>
                          Instalación en Servidores Apache o Nginx: Para
                          servidores que utilizan Apache o Nginx, deberás
                          configurar el archivo de configuración del servidor.
                          Agrega la ruta del certificado principal, la clave
                          privada y, si es necesario, el archivo de la cadena
                          intermedia.
                        </ServiceListElement>
                        <ServiceListElement>
                          Instalación en Servidores Microsoft IIS: En servidores
                          IIS, utiliza el Administrador de Certificados en el
                          Panel de Control. Importa el certificado principal y
                          la clave privada en el almacén de certificados.
                        </ServiceListElement>
                        <ServiceListElement>
                          Reinicia el Servidor Web: Después de instalar el
                          certificado, reinicia el servidor web para aplicar los
                          cambios.
                        </ServiceListElement>
                        <ServiceListElement>
                          Verifica la Instalación: Utiliza herramientas en línea
                          o navegadores web para verificar que el certificado
                          SSL esté instalado correctamente y que la conexión
                          esté segura.
                        </ServiceListElement>
                      </ServiceList>
                      <Text>
                        Recuerda que estos son pasos generales y los detalles
                        específicos pueden variar según tu entorno de servidor
                        web. Siempre sigue las instrucciones proporcionadas por
                        GeoTrust y la documentación de tu servidor web. Además,
                        considera realizar copias de seguridad antes de realizar
                        cambios en la configuración del servidor.
                      </Text>
                    </Accordion.Body>
                  </Accordion.Item>
                  {/* Item 6 */}
                  <Accordion.Item eventKey="6">
                    <Accordion.Header>
                      ¿Cómo generar un CSR o instalar un SSL según el servidor?
                    </Accordion.Header>
                    <Accordion.Body>
                      <Text>
                        Ver ayudas en vídeo:{" "}
                        <TextaSpan to="/certificados-ssl">
                          <strong> Generar un CSR</strong>
                        </TextaSpan>{" "}
                        o{" "}
                        <TextaSpan to="/certificados-ssl">
                          <strong> instalar un SSL</strong>
                        </TextaSpan>
                      </Text>
                    </Accordion.Body>
                  </Accordion.Item>
                  {/* Item 7 */}
                  <Accordion.Item eventKey="7">
                    <Accordion.Header>
                      ¿Cómo comprobar un CSR o un SSL?
                    </Accordion.Header>
                    <Accordion.Body>
                      <Text>
                        <Texta
                          href="https://www.digicert.com/ssltools/view-csr"
                          target="_blank"
                          rel="nofollow noreferrer noopener"
                        >
                          <strong> Comprobar un CSR</strong>
                        </Texta>{" "}
                        o{" "}
                        <Texta
                          href="https://www.digicert.com/help/"
                          target="_blank"
                          rel="nofollow noreferrer noopener"
                        >
                          <strong> comprobar un SSL</strong>
                        </Texta>
                      </Text>
                    </Accordion.Body>
                  </Accordion.Item>
                  {/* Item 8 */}
                  <Accordion.Item eventKey="8">
                    <Accordion.Header>
                      ¿Cuál es la diferencia entre GeoTrust y DigiCert?
                    </Accordion.Header>
                    <Accordion.Body>
                      <Text>
                        GeoTrust y DigiCert, dos nombres destacados en el mundo
                        de la seguridad en línea, comparten una conexión más
                        profunda de la que aparenta. DigiCert adquirió GeoTrust,
                        consolidando su presencia en el mercado de certificados
                        SSL. En esencia, ambas marcas ofrecen soluciones de
                        seguridad digital de alta calidad. DigiCert, como
                        empresa matriz, extiende su experiencia a través de
                        GeoTrust, manteniendo estándares de excelencia. Las
                        diferencias específicas pueden residir en las
                        características particulares de los productos y
                        servicios que ofrecen. Si estás considerando
                        certificados SSL, evalúa las ofertas actuales de ambas
                        marcas, ya que la evolución empresarial puede haber
                        introducido nuevas sinergias. La clave está en
                        comprender las necesidades específicas de seguridad que
                        buscas y seleccionar la opción que mejor se alinee con
                        tus objetivos digitales.
                      </Text>
                    </Accordion.Body>
                  </Accordion.Item>
                  {/* Item 9 */}
                  <Accordion.Item eventKey="9">
                    <Accordion.Header>
                      ¿Cómo elegir un SSL para mi app en Bogotá?
                    </Accordion.Header>
                    <Accordion.Body>
                      <Text>
                        Para apps en Bogotá, elige un SSL según tu necesidad: DV
                        para apps básicas, OV para empresas, o EV para máxima
                        confianza. Contáctanos para una recomendación
                        personalizada.
                      </Text>
                    </Accordion.Body>
                  </Accordion.Item>
                  {/* Item 10 */}
                  <Accordion.Item eventKey="10">
                    <Accordion.Header>
                      ¿Puedo obtener un SSL gratis con hosting?
                    </Accordion.Header>
                    <Accordion.Body>
                      <Text>
                        Sí, ofrecemos SSL gratis con nuestros planes de hosting
                        en Bogotá, Medellín, Barranquilla, Pereira y Cali.
                        Perfecto para sitios y aplicaciones web básicas.
                      </Text>
                    </Accordion.Body>
                  </Accordion.Item>
                  {/* Item 11 */}
                  <Accordion.Item eventKey="11">
                    <Accordion.Header>
                      ¿Qué es un SSL Wildcard?
                    </Accordion.Header>
                    <Accordion.Body>
                      <Text>
                        Un certificado SSL Wildcard protege un dominio y todos
                        sus subdominios ilimitados (*.dominio.com). Ideal para
                        desarrolladores y redes de sitios en Colombia.
                      </Text>
                    </Accordion.Body>
                  </Accordion.Item>
                  {/* Item 12 */}
                  <Accordion.Item eventKey="12">
                    <Accordion.Header>
                      ¿Por qué elegir DigiCert en Medellín?
                    </Accordion.Header>
                    <Accordion.Body>
                      <Text>
                        DigiCert ofrece máxima seguridad y confianza para
                        plataformas en Medellín, con validación EV y soporte
                        premium. Es ideal para empresas que priorizan
                        profesionalismo.
                      </Text>
                    </Accordion.Body>
                  </Accordion.Item>
                  {/* Item 13 */}
                  <Accordion.Item eventKey="13">
                    <Accordion.Header>
                      ¿Cuánto tarda la emisión de un SSL DV?
                    </Accordion.Header>
                    <Accordion.Body>
                      <Text>
                        Un certificado SSL DV se emite en minutos tras verificar
                        el dominio, lo que lo hace ideal para sitios y apps que
                        necesitan seguridad rápida en Colombia.
                      </Text>
                    </Accordion.Body>
                  </Accordion.Item>
                  {/* Item 14 */}
                  <Accordion.Item eventKey="14">
                    <Accordion.Header>
                      ¿Cómo protege un SSL mi plataforma en Barranquilla?
                    </Accordion.Header>
                    <Accordion.Body>
                      <Text>
                        Un SSL cifra los datos de tu plataforma en Barranquilla,
                        protegiendo a tus usuarios y mejorando la confianza. Es
                        esencial para extranets y apps locales.
                      </Text>
                    </Accordion.Body>
                  </Accordion.Item>
                  {/* Item 15 */}
                  <Accordion.Item eventKey="15">
                    <Accordion.Header>
                      ¿Son seguros los SSL para pymes en Bucaramanga?
                    </Accordion.Header>
                    <Accordion.Body>
                      <Text>
                        Sí, los certificados SSL son seguros y accesibles para
                        pymes en Bucaramanga. Ofrecemos opciones económicas
                        (desde $50.000/año) con garantía de 30 días.
                      </Text>
                    </Accordion.Body>
                  </Accordion.Item>
                  {/* Item 16 */}
                  <Accordion.Item eventKey="16">
                    <Accordion.Header>
                      ¿Qué SSL es mejor para una tienda online en Cali?
                    </Accordion.Header>
                    <Accordion.Body>
                      <Text>
                        Para tiendas online en Cali, recomendamos un SSL EV
                        (DigiCert) para máxima confianza o un SSL OV (GeoTrust)
                        para pymes. Aseguran pagos y datos de clientes.
                      </Text>
                    </Accordion.Body>
                  </Accordion.Item>
                  {/* Item 17 */}
                  <Accordion.Item eventKey="17">
                    <Accordion.Header>
                      ¿Qué es el error ERR_SSL_PROTOCOL_ERROR?
                    </Accordion.Header>
                    <Accordion.Body>
                      <Text>
                        Este error ocurre cuando el navegador no puede establecer
                        una conexión segura debido a problemas con la configuración
                        SSL/TLS, el servidor o el dispositivo del cliente. Las causas
                        comunes incluyen:<br></br>
                        - Certificado SSL mal configurado en el servidor.<br></br>
                        - Protocolos o cifrados SSL/TLS desactualizados.<br></br>
                        - Problemas de red en el servidor o el cliente.<br></br>
                        - Fecha/hora incorrectas en el dispositivo del cliente.
                      </Text>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </AnimationContainer>
            </Col>
          </ServiceRow1>
        </Container>
      </Section>
    )
  }
}

export default Digicert
